import React from 'react';
import AssistantBotRow from '../shells/AssistantBotRow';
import UserReplyRow from '../shells/UserReplyRow';
import { applicationSummaryBubbleText, stepQuestionKey } from './careerUpApplicationSteps';
import type { useCareerUpApplicationFlow } from './useCareerUpApplicationFlow';

type Flow = ReturnType<typeof useCareerUpApplicationFlow>;

export default function CareerUpApplicationChatThread({ flow }: { flow: Flow }) {
  const {
    t,
    committed,
    isComplete,
    hasCardConflict,
    currentStep,
    assistantQuestionVisible,
    showSummaryBlock,
    editingCommitIndex,
  } = flow;
  const undoLabel = t('submitDocuments.chat.undo');
  const editLabel = t('submitDocuments.fillFormsChecklist.edit');

  const committedStepIds = new Set(committed.map((c) => c.stepId));
  const isEditing = editingCommitIndex !== null;

  return (
    <>
      {committed.map((c, i) => (
        <React.Fragment key={`${c.stepId}-${i}`}>
          {c.stepId === 'confirmNoCard' && (
            <AssistantBotRow animateIn>{t(stepQuestionKey('confirmNoCard'))}</AssistantBotRow>
          )}
          {c.stepId === 'readConsentDocument' && (
            <AssistantBotRow animateIn>{t(stepQuestionKey('readConsentDocument'))}</AssistantBotRow>
          )}
          {c.stepId === 'agreeApply' && showSummaryBlock && (
            <AssistantBotRow animateIn>{applicationSummaryBubbleText(t)}</AssistantBotRow>
          )}
          <UserReplyRow
            displayText={c.displayText}
            showEdit={flow.showEditForCommitIndex(i)}
            onEdit={() => flow.jumpToEditCommitIndex(i)}
            editLabel={editLabel}
            showUndo={flow.showUndoForCommitIndex(i)}
            onUndo={flow.undo}
            undoLabel={undoLabel}
          />
        </React.Fragment>
      ))}

      {hasCardConflict && (
        <AssistantBotRow animateIn>{t('submitDocuments.careerUpApplication.hasCardMessage')}</AssistantBotRow>
      )}

      {!isComplete && !hasCardConflict && currentStep && assistantQuestionVisible && (
        <>
          {currentStep.stepId === 'confirmNoCard' &&
            (isEditing || !committedStepIds.has('confirmNoCard')) && (
              <AssistantBotRow animateIn>{t(stepQuestionKey('confirmNoCard'))}</AssistantBotRow>
            )}
          {currentStep.stepId === 'readConsentDocument' &&
            (isEditing || !committedStepIds.has('readConsentDocument')) && (
              <AssistantBotRow animateIn>{t(stepQuestionKey('readConsentDocument'))}</AssistantBotRow>
            )}
          {currentStep.stepId === 'agreeApply' && (isEditing || !committedStepIds.has('agreeApply')) && (
            <AssistantBotRow animateIn>{applicationSummaryBubbleText(t)}</AssistantBotRow>
          )}
        </>
      )}
    </>
  );
}
